
export default
[
    {title: "Cars.Label.timeToOdometerRecord", dataIndex: "timeToOdometerRecord", key: "timeToOdometerRecord", responsive: ['sm']},
    {title: "Cars.Label.key", dataIndex: "key", key: "key", width: "100px"},
    {title: "Cars.Label.companyBarnchName", dataIndex: "companyBarnchName", key: "companyBarnchName", responsive: ['md']},
    {title: "Cars.Label.carIdNumber", dataIndex: "carIdNumber", key: "carIdNumber",responsive: ['md'],
    
    
  //  filteredValue: [searchText],
    onFilter:(value: any,record: { carIdNumber: string | any[]; })=>{
    return record.carIdNumber.includes(value);
    },

   
},



    {title: "Cars.Label.consumptionValue", dataIndex: "consumptionValue", key: "consumptionValue", responsive: ['md']},
    {title: "Cars.Label.consumptionMethod", dataIndex: "consumptionMethod", key: "consumptionMethod", responsive: ['md']},
   
    {title: "Cars.Label.carBalnce", dataIndex: "carBalnce", key: "carBalnce",responsive: ['md']},

    {title: "Cars.Label.carType", dataIndex: "carType", key: "carType", responsive: ['md']},
    {title: "Cars.Label.carBrand", dataIndex: "carBrand", key: "carBrand", responsive: ['md']},
    {title: "Cars.Label.carDriverName", dataIndex: "carDriverName", key: "carDriverName", responsive: ['md']},
    {title: "Cars.Label.carDriverActive", dataIndex: "carDriverActive", key: "carDriverActive", responsive: ['sm']},


    /*{title: "Cars.Label.carIdText1E", dataIndex: "carIdText1E", key: "carIdText1E", width: "100px"},
    {title: "Cars.Label.carIdText1A", dataIndex: "carIdText1A", key: "carIdText1A", width: "100px"},
    {title: "Cars.Label.carIdNumber1E", dataIndex: "carIdNumber1E", key: "carIdNumber1E", width: "100px"},
    {title: "Cars.Label.consumptionType", dataIndex: "consumptionType", key: "consumptionType", width: "100px"},
    {title: "Cars.Label.companyBarnchId", dataIndex: "companyBarnchId", key: "companyBarnchId", width: "100px"},

    {title: "Cars.Label.saturday", dataIndex: "saturday", key: "saturday", width: "60px" },
    {title: "Cars.Label.sunday", dataIndex: "sunday", key: "sunday", width: "60px" },
    {title: "Cars.Label.monday", dataIndex: "monday", key: "monday", width: "60px" },
    {title: "Cars.Label.tuesday", dataIndex: "tuesday", key: "tuesday", width: "60px" },
    {title: "Cars.Label.wednesday", dataIndex: "wednesday", key: "wednesday", width: "60px" },
    {title: "Cars.Label.thursday", dataIndex: "thursday", key: "thursday", width: "60px" },
    {title: "Cars.Label.friday", dataIndex: "friday", key: "friday", width: "60px" },


    {title: "Cars.Label.carModel", dataIndex: "carModel", key: "carModel", width: "100px"},
    {title: "Cars.Label.carModelYear", dataIndex: "carModelYear", key: "carModelYear", width: "100px"},
    {title: "Cars.Label.carTypeOfFuel", dataIndex: "carTypeOfFuel", key: "carTypeOfFuel", width: "100px"},
    {title: "Cars.Label.carNeedPlatePhoto", dataIndex: "carNeedPlatePhoto", key: "carNeedPlatePhoto", width: "100px"},

    {title: "Cars.Label.carDriverPhoneNumber", dataIndex: "carDriverPhoneNumber", key: "carDriverPhoneNumber", width: "100px"},
    {title: "Cars.Label.carDriverUserName", dataIndex: "carDriverUserName", key: "carDriverUserName", width: "100px"},
    /!*{title: "Cars.Label.carDriverPassword", dataIndex: "carDriverPassword", key: "carDriverPassword", width: "100px"},*!/
    {title: "Cars.Label.carDriverEmail", dataIndex: "carDriverEmail", key: "carDriverEmail", width: "100px"},

    {title: "Cars.Label.carDriverConfirmationCode", dataIndex: "carDriverConfirmationCode", key: "carDriverConfirmationCode", width: "100px"},
    /!*{title: "Cars.Label.carPlatePhoto", dataIndex: "carPlatePhoto", key: "carPlatePhoto", width: "100px},*!/
    {title: "Cars.Label.carWorkWithApproval", dataIndex: "carWorkWithApproval", key: "carWorkWithApproval", width: "60px" },
    {title: "Cars.Label.carApprovedOneTime", dataIndex: "carApprovedOneTime", key: "carApprovedOneTime", width: "60px" },
    {title: "Cars.Label.workAllDays", dataIndex: "workAllDays", key: "workAllDays", width: "60px" },
    {title: "Cars.Label.carNfcCode", dataIndex: "carNfcCode", key: "carNfcCode", width: "100px"}*/
]

